/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms.fk02

import io.kvision.redux.RAction

enum class FormularzWidok {
    PUSTY,
    NOWY,
    EDYCJA
}

data class Formularz(
    val widok: FormularzWidok,
    val form: Fk02Form? = null,
    val token: String? = null,
    val bladZapisu: String? = null

)

sealed class FormularzAction : RAction {
    data class Nowy(val formData: Fk02FormData) : FormularzAction()
    data class Edycja(val formData: Fk02FormData) : FormularzAction()
    data class BladZapisu(val bladZapisu: String, val aktualnyForm: Fk02Form) : FormularzAction()
}

fun formularzReducer(state: Formularz, action: FormularzAction): Formularz = when (action) {
    is FormularzAction.Nowy -> {
        Formularz(
                FormularzWidok.NOWY,
                action.formData.form,
                action.formData.token,
                bladZapisu = null
        )
    }
    is FormularzAction.Edycja -> {
        Formularz(
                FormularzWidok.EDYCJA,
                action.formData.form,
                action.formData.token,
                bladZapisu = null
        )
    }
    is FormularzAction.BladZapisu -> {
        state.copy(bladZapisu = action.bladZapisu, form = action.aktualnyForm)
    }
}
